import { EmptyStateProps } from './EmptyStateProps.ts';
import './EmptyState.scss';
import { useEffect, useRef } from 'react';

const EmptyState: React.FC<EmptyStateProps & { focused?: boolean }> = ({
	image,
	headline,
	description,
	callToAction,
	focused,
}) => {
	const ref = useRef<HTMLButtonElement>(null);

	useEffect(() => {
		if (focused) {
			ref.current?.focus();
		}
	}, [focused]);

	return (
		<div className="blk-ac-empty-state">
			<div className="empty-state-pictogram">
				<img src={image.path} alt={image.alt} data-final-url />
			</div>
			<div
				className={`empty-state-action-container ${
					callToAction ? '' : 'no-cta-button'
				}`}
			>
				<div className="empty-state-text-container">
					<div className="empty-state-headline">{headline}</div>
					<div className="empty-state-description">{description}</div>
				</div>
				{callToAction && (
					<button
						className={`blk-ac-primary-button ${
							callToAction.className || ''
						} empty-state-cta-button`}
						onClick={callToAction.ctaCallback}
						aria-label={callToAction.ariaLabel}
						data-link-event={callToAction.dataLinkEvent}
						ref={ref}
						tabIndex={0}
					>
						{callToAction.label}
					</button>
				)}
			</div>
		</div>
	);
};

export default EmptyState;
